export enum BusinessReviewStatus {
  Request = 'REQUEST',
  Approve = 'APPROVE',
  Reject = 'REJECT'
}
